// Assets
import 'reset-css'
import 'leaflet/dist/leaflet.css'
import '@/assets/stylesheets/main.scss'
import '@/assets/icons'

// Vendors
import Vue from 'vue'
import VueI18n from 'vue-i18n'
import SvgIcon from 'vue-svgicon'
import Meta from 'vue-meta'
import Buefy from 'buefy'
import VeeValidate, { Validator } from 'vee-validate'
import { VueTelInput } from 'vue-tel-input'
import VueRaven from 'vue-raven'
import VueCroppie from 'vue-croppie'
import InfiniteScroll from 'vue-infinite-scroll'
import VueQrcode from '@xkeshi/vue-qrcode'
import VueMq from 'vue-mq'

// App
import App from './views/App.vue'
import router from './router/index'
import store from './store/index'
import api from './api'
import './filters/String'

// Layouts
import Default from './layouts/Default.vue'
import Public from './layouts/Public.vue'
Vue.component('default-layout', Default)
Vue.component('public-layout', Public)
Vue.component(VueQrcode.name, VueQrcode)

// Helpers
import { addStickyBehaviors } from './helpers/sticky'

// Plugins
Vue.use(Buefy)
Vue.use(VeeValidate)

Vue.component('vue-tel-input', VueTelInput)
Vue.use(VueCroppie)

Vue.use(InfiniteScroll)
Vue.use(VueRaven, {
  dsn: 'https://09aab08db6034b7a9f7a583d4e85e1ed@sentry.io/1285987'
})
Vue.use(VueI18n)
Vue.use(Meta)
Vue.use(SvgIcon, {
  tagName: 'svgicon'
})
Vue.use(VueMq, {
  breakpoints: {
    sm: 450,
    md: 1024,
    lg: Infinity,
  }
})

// Config
Vue.prototype.$addStickyBehaviors = addStickyBehaviors
Vue.prototype.$api = api
Vue.prototype.$preferredCountries = ['fr', 'be', 'ch', 'de', 'es', 'us', 'pt', 'it', 'pl']
Vue.prototype.$locales = process.env.VUE_APP_ACTIVE_LANGUAGES.split(',')
Vue.prototype.$trialUrl = process.env.VUE_APP_TRIAL_URL
Vue.prototype.$env = process.env.NODE_ENV
Vue.config.productionTip = false

// TODO add helpers in Prototype
// Vue.prototype.$helpers = { downloadFileUrl ... }

const i18n = new VueI18n({
  locale: 'fr',
  fallbackLocale: 'fr',
  messages: {
    fr: require('./translations/fr.json'),
    en: require('./translations/en.json'),
    de: require('./translations/de.json'),
    es: require('./translations/es.json'),
    it: require('./translations/it.json'),
    nl: require('./translations/nl.json'),
    pl: require('./translations/pl.json'),
    pt: require('./translations/pt.json')
  }
})

// Vue Instance
const vm = new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount('#app')

// Exports
export { vm, i18n }
